/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: k4MoYHGY6d3NVAoA3aDDg2
// Component: _9iHutwm7rWJ

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import {
  executePlasmicDataOp,
  usePlasmicDataOp,
  usePlasmicInvalidate
} from "@plasmicapp/react-web/lib/data-sources";

import { SupabaseDataProvider } from "@/components/SupabaseDataProvider"; // plasmic-import: yj_J6waDJ0RW/codeComponent
import { AntdModal } from "@plasmicpkgs/antd5/skinny/registerModal";
import { AntdTabs } from "@plasmicpkgs/antd5/skinny/registerTabs";
import { AntdTabItem } from "@plasmicpkgs/antd5/skinny/registerTabs";
import { FormWrapper } from "@plasmicpkgs/antd5/skinny/Form";
import { formHelpers as FormWrapper_Helpers } from "@plasmicpkgs/antd5/skinny/Form";
import { FormItemWrapper } from "@plasmicpkgs/antd5/skinny/FormItem";
import { AntdSelect } from "@plasmicpkgs/antd5/skinny/registerSelect";
import Slider from "../../Slider"; // plasmic-import: 9JFlRRXCovWN/component
import SliderThumb from "../../SliderThumb"; // plasmic-import: L0ZgEQdcWs2z/component
import { AntdTextArea } from "@plasmicpkgs/antd5/skinny/registerInput";
import { inputHelpers as AntdTextArea_Helpers } from "@plasmicpkgs/antd5/skinny/registerInput";
import { AntdButton } from "@plasmicpkgs/antd5/skinny/registerButton";
import { AntdSegmented } from "@plasmicpkgs/antd5/skinny/registerSegmented";
import { AntdSegmentedOption } from "@plasmicpkgs/antd5/skinny/registerSegmented";
import { AntdSteps } from "@plasmicpkgs/antd5/skinny/registerSteps";
import { Embed } from "@plasmicpkgs/plasmic-basic-components";
import { RichTable } from "@plasmicpkgs/plasmic-rich-components/skinny/rich-table";
import { tableHelpers as RichTable_Helpers } from "@plasmicpkgs/plasmic-rich-components/skinny/rich-table";
import { JoditEditor } from "@/components/Jodit"; // plasmic-import: -BRO0CmVFRYO/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/styleTokensProvider


import sty from "./PlasmicReportIssue.module.css"; // plasmic-import: _9iHutwm7rWJ/css

import ReportSvgIcon from "./icons/PlasmicIcon__ReportSvg"; // plasmic-import: aPBs-B5NsK1Q/icon
import SignatureSvgIcon from "./icons/PlasmicIcon__SignatureSvg"; // plasmic-import: GFydSi8RZYSf/icon

createPlasmicElementProxy;

export type PlasmicReportIssue__VariantMembers = {};
export type PlasmicReportIssue__VariantsArgs = {};
type VariantPropType = keyof PlasmicReportIssue__VariantsArgs;
export const PlasmicReportIssue__VariantProps = new Array<VariantPropType>();

export type PlasmicReportIssue__ArgsType = {};
type ArgPropType = keyof PlasmicReportIssue__ArgsType;
export const PlasmicReportIssue__ArgProps = new Array<ArgPropType>();

export type PlasmicReportIssue__OverridesType = {
  root?: Flex__<"div">;
  modal?: Flex__<typeof AntdModal>;
  tabs?: Flex__<typeof AntdTabs>;
  form?: Flex__<typeof FormWrapper>;
  select?: Flex__<typeof AntdSelect>;
  slider?: Flex__<typeof Slider>;
  select2?: Flex__<typeof AntdSelect>;
  select3?: Flex__<typeof AntdSelect>;
  textArea3?: Flex__<typeof AntdTextArea>;
  textArea4?: Flex__<typeof AntdTextArea>;
  textArea5?: Flex__<typeof AntdTextArea>;
  textArea2?: Flex__<typeof AntdTextArea>;
  segmented?: Flex__<typeof AntdSegmented>;
  steps?: Flex__<typeof AntdSteps>;
  embedHtml?: Flex__<typeof Embed>;
  select7?: Flex__<typeof AntdSelect>;
  modal2?: Flex__<typeof AntdModal>;
  segmented2?: Flex__<typeof AntdSegmented>;
  table?: Flex__<typeof RichTable>;
  form2?: Flex__<typeof FormWrapper>;
  textArea10?: Flex__<typeof AntdTextArea>;
  select5?: Flex__<typeof AntdSelect>;
  select6?: Flex__<typeof AntdSelect>;
  select4?: Flex__<typeof AntdSelect>;
  textArea6?: Flex__<typeof AntdTextArea>;
  textArea7?: Flex__<typeof AntdTextArea>;
  textArea8?: Flex__<typeof AntdTextArea>;
  textArea9?: Flex__<typeof AntdTextArea>;
  joditEditor?: Flex__<typeof JoditEditor>;
};

export interface DefaultReportIssueProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicReportIssue__RenderFunc(props: {
  variants: PlasmicReportIssue__VariantsArgs;
  args: PlasmicReportIssue__ArgsType;
  overrides: PlasmicReportIssue__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "modal.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $ctx.support_tickets
            ?.map(item => [4, 11].includes(item.status_id))
            .some(Boolean)
      },
      {
        path: "form.value",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "form",
        onMutate: generateOnMutateForSpec("value", FormWrapper_Helpers)
      },
      {
        path: "form.isSubmitting",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false,

        refName: "form",
        onMutate: generateOnMutateForSpec("isSubmitting", FormWrapper_Helpers)
      },
      {
        path: "select.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "tabs.activeKey",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "2"
      },
      {
        path: "select2.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "slider.value",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0
      },
      {
        path: "textArea2.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("value", AntdTextArea_Helpers)
      },
      {
        path: "select3.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "textArea3.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("value", AntdTextArea_Helpers)
      },
      {
        path: "textArea4.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("value", AntdTextArea_Helpers)
      },
      {
        path: "textArea5.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("value", AntdTextArea_Helpers)
      },
      {
        path: "steps[].current",
        type: "private",
        variableType: "number"
      },
      {
        path: "faultyTicket",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ({})
      },
      {
        path: "segmented.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "1"
      },
      {
        path: "adminIds",
        type: "private",
        variableType: "array",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => [5]
      },
      {
        path: "modal2.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $ctx.support_tickets
            ?.map(item => ![4, 11, 5].includes(item.status_id))
            .some(Boolean)
      },
      {
        path: "table.selectedRowKey",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("selectedRowKey", RichTable_Helpers)
      },
      {
        path: "table.selectedRow",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("selectedRow", RichTable_Helpers)
      },
      {
        path: "table.selectedRows",
        type: "private",
        variableType: "array",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("selectedRows", RichTable_Helpers)
      },
      {
        path: "table.selectedRowKeys",
        type: "private",
        variableType: "array",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("selectedRowKeys", RichTable_Helpers)
      },
      {
        path: "form2.value",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "form2",
        onMutate: generateOnMutateForSpec("value", FormWrapper_Helpers)
      },
      {
        path: "form2.isSubmitting",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false,

        refName: "form2",
        onMutate: generateOnMutateForSpec("isSubmitting", FormWrapper_Helpers)
      },
      {
        path: "select5.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "select6.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "textArea6.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("value", AntdTextArea_Helpers)
      },
      {
        path: "textArea7.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("value", AntdTextArea_Helpers)
      },
      {
        path: "textArea8.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("value", AntdTextArea_Helpers)
      },
      {
        path: "textArea9.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("value", AntdTextArea_Helpers)
      },
      {
        path: "select4.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "segmented2.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 1
      },
      {
        path: "textArea10.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec("value", AntdTextArea_Helpers)
      },
      {
        path: "select7.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return (() => {
                let value = "en";
                if ($ctx.layout?.userPrefs?.language != value) {
                  value = $ctx.layout?.userPrefs?.language;
                }
                return value;
              })();
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "en";
              }
              throw e;
            }
          })()
      },
      {
        path: "joditEditor.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $globalActions = useGlobalActions?.();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const dataSourcesCtx = usePlasmicDataSourceContext();
  const plasmicInvalidate = usePlasmicInvalidate();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {(() => {
        try {
          return $ctx.layout.id != 5;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div
          className={classNames("all", sty.freeBox__iH6Ps, {
            [sty.freeBoxglobal_locale_spanish__iH6PsjTbLa]: hasVariant(
              globalVariants,
              "locale",
              "spanish"
            )
          })}
        >
          <SupabaseDataProvider
            alwaysClient={false}
            blockingLoad={false}
            className={classNames(
              "__wab_instance",
              sty.supabaseDataProviderTable__rs0JH
            )}
            match={(() => {
              return (
                "or=(created_by.eq." +
                $ctx.layout?.id +
                ",updater_id.eq." +
                $ctx.layout?.id +
                ")"
              );
            })()}
            onRealtimeTrigger={async payload => {
              const $steps = {};

              $steps["runCode"] = true
                ? (() => {
                    const actionArgs = {
                      customFunction: async () => {
                        return console.log(payload);
                      }
                    };
                    return (({ customFunction }) => {
                      return customFunction();
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runCode"] != null &&
                typeof $steps["runCode"] === "object" &&
                typeof $steps["runCode"].then === "function"
              ) {
                $steps["runCode"] = await $steps["runCode"];
              }
            }}
            selectQuery={"*"}
            tableName={"support_tickets"}
          >
            <DataCtxReader__>
              {$ctx => (
                <React.Fragment>
                  <div
                    className={classNames("all", sty.freeBox__pSjj0)}
                    onClick={async event => {
                      const $steps = {};

                      $steps["updateModalOpen"] = true
                        ? (() => {
                            const actionArgs = {
                              variable: {
                                objRoot: $state,
                                variablePath: ["modal", "open"]
                              },
                              operation: 0,
                              value: true
                            };
                            return (({
                              variable,
                              value,
                              startIndex,
                              deleteCount
                            }) => {
                              if (!variable) {
                                return;
                              }
                              const { objRoot, variablePath } = variable;

                              $stateSet(objRoot, variablePath, value);
                              return value;
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["updateModalOpen"] != null &&
                        typeof $steps["updateModalOpen"] === "object" &&
                        typeof $steps["updateModalOpen"].then === "function"
                      ) {
                        $steps["updateModalOpen"] =
                          await $steps["updateModalOpen"];
                      }

                      $steps["updateModalOpen2"] = true
                        ? (() => {
                            const actionArgs = {
                              variable: {
                                objRoot: $state,
                                variablePath: ["tabs", "activeKey"]
                              },
                              operation: 0,
                              value: "1"
                            };
                            return (({
                              variable,
                              value,
                              startIndex,
                              deleteCount
                            }) => {
                              if (!variable) {
                                return;
                              }
                              const { objRoot, variablePath } = variable;

                              $stateSet(objRoot, variablePath, value);
                              return value;
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["updateModalOpen2"] != null &&
                        typeof $steps["updateModalOpen2"] === "object" &&
                        typeof $steps["updateModalOpen2"].then === "function"
                      ) {
                        $steps["updateModalOpen2"] =
                          await $steps["updateModalOpen2"];
                      }
                    }}
                  >
                    <ReportSvgIcon
                      className={classNames("all", sty.svg___6Qh4U)}
                      role={"img"}
                    />
                  </div>
                  {(() => {
                    const child$Props = {
                      className: classNames("__wab_instance", sty.modal),
                      defaultStylesClassName: classNames(
                        "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                        "plasmic_default_styles",
                        "plasmic_mixins",
                        styleTokensClassNames
                      ),
                      hideFooter: true,
                      modalScopeClassName: sty["modal__modal"],
                      onOpenChange: async (...eventArgs: any) => {
                        generateStateOnChangeProp($state, [
                          "modal",
                          "open"
                        ]).apply(null, eventArgs);
                      },
                      open: generateStateValueProp($state, ["modal", "open"]),
                      title: (
                        <React.Fragment>
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__x3PO,
                              {
                                [sty.textglobal_locale_spanish__x3POjTbLa]:
                                  hasVariant(
                                    globalVariants,
                                    "locale",
                                    "spanish"
                                  )
                              }
                            )}
                          >
                            {hasVariant(globalVariants, "locale", "spanish")
                              ? "Abrir un ticket"
                              : "Open ticket"}
                          </div>
                          {(() => {
                            const child$Props = {
                              className: classNames(
                                "__wab_instance",
                                sty.select7
                              ),
                              defaultStylesClassName: classNames(
                                "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                                "plasmic_default_styles",
                                "plasmic_mixins",
                                styleTokensClassNames
                              ),
                              defaultValue: (() => {
                                try {
                                  return (() => {
                                    let value = "en";
                                    if (
                                      $ctx.layout?.userPrefs?.language != value
                                    ) {
                                      value = $ctx.layout?.userPrefs?.language;
                                    }
                                    return value;
                                  })();
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return "en";
                                  }
                                  throw e;
                                }
                              })(),
                              onChange: async (...eventArgs: any) => {
                                generateStateOnChangeProp($state, [
                                  "select7",
                                  "value"
                                ]).apply(null, eventArgs);

                                (async (value, option) => {
                                  const $steps = {};

                                  $steps["invokeGlobalAction"] = true
                                    ? (() => {
                                        const actionArgs = {
                                          args: ["language", value]
                                        };
                                        return $globalActions[
                                          "PreferencesProvider.set"
                                        ]?.apply(null, [...actionArgs.args]);
                                      })()
                                    : undefined;
                                  if (
                                    $steps["invokeGlobalAction"] != null &&
                                    typeof $steps["invokeGlobalAction"] ===
                                      "object" &&
                                    typeof $steps["invokeGlobalAction"].then ===
                                      "function"
                                  ) {
                                    $steps["invokeGlobalAction"] =
                                      await $steps["invokeGlobalAction"];
                                  }

                                  $steps["runCode"] = true
                                    ? (() => {
                                        const actionArgs = {
                                          customFunction: async () => {
                                            return window.location.reload();
                                          }
                                        };
                                        return (({ customFunction }) => {
                                          return customFunction();
                                        })?.apply(null, [actionArgs]);
                                      })()
                                    : undefined;
                                  if (
                                    $steps["runCode"] != null &&
                                    typeof $steps["runCode"] === "object" &&
                                    typeof $steps["runCode"].then === "function"
                                  ) {
                                    $steps["runCode"] = await $steps["runCode"];
                                  }
                                }).apply(null, eventArgs);
                              },
                              options: (() => {
                                const __composite = [
                                  { value: null, label: null, type: "option" },
                                  { value: null, label: null, type: "option" }
                                ];
                                __composite["0"]["value"] = "spanish";
                                __composite["0"]["label"] = "Espa\u00f1ol";
                                __composite["1"]["value"] = "english";
                                __composite["1"]["label"] = "English";
                                return __composite;
                              })(),

                              placeholder: "Language",
                              popupScopeClassName: sty["select7__popup"],
                              value: generateStateValueProp($state, [
                                "select7",
                                "value"
                              ])
                            };
                            initializeCodeComponentStates(
                              $state,
                              [
                                {
                                  name: "value",
                                  plasmicStateName: "select7.value"
                                }
                              ],
                              [],
                              undefined ?? {},
                              child$Props
                            );
                            initializePlasmicStates(
                              $state,
                              [
                                {
                                  name: "select7.value",
                                  initFunc: ({
                                    $props,
                                    $state,
                                    $queries,
                                    $q
                                  }) =>
                                    (() => {
                                      try {
                                        return (() => {
                                          let value = "en";
                                          if (
                                            $ctx.layout?.userPrefs?.language !=
                                            value
                                          ) {
                                            value =
                                              $ctx.layout?.userPrefs?.language;
                                          }
                                          return value;
                                        })();
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return "en";
                                        }
                                        throw e;
                                      }
                                    })()
                                }
                              ],
                              []
                            );
                            return (
                              <AntdSelect
                                data-plasmic-name={"select7"}
                                data-plasmic-override={overrides.select7}
                                {...child$Props}
                              />
                            );
                          })()}
                        </React.Fragment>
                      ),
                      trigger: null,
                      width: "50%"
                    };
                    initializeCodeComponentStates(
                      $state,
                      [
                        {
                          name: "open",
                          plasmicStateName: "modal.open"
                        }
                      ],
                      [],
                      undefined ?? {},
                      child$Props
                    );
                    initializePlasmicStates(
                      $state,
                      [
                        {
                          name: "modal.open",
                          initFunc: ({ $props, $state, $queries, $q }) =>
                            $ctx.support_tickets
                              ?.map(item => [4, 11].includes(item.status_id))
                              .some(Boolean)
                        }
                      ],
                      []
                    );
                    return (
                      <AntdModal
                        data-plasmic-name={"modal"}
                        data-plasmic-override={overrides.modal}
                        {...child$Props}
                      >
                        <AntdTabs
                          data-plasmic-name={"tabs"}
                          data-plasmic-override={overrides.tabs}
                          activeKey={generateStateValueProp($state, [
                            "tabs",
                            "activeKey"
                          ])}
                          animateTabBar={true}
                          animateTabContent={false}
                          animated={true}
                          className={classNames("__wab_instance", sty.tabs, {
                            [sty.tabsglobal_locale_spanish]: hasVariant(
                              globalVariants,
                              "locale",
                              "spanish"
                            )
                          })}
                          defaultActiveKey={"2"}
                          items={
                            <React.Fragment>
                              <AntdTabItem
                                className={classNames(
                                  "__wab_instance",
                                  sty.tabItem__isTg4
                                )}
                                key={"1"}
                                label={
                                  <div
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.text__wrV0L,
                                      {
                                        [sty.textglobal_locale_spanish__wrV0LjTbLa]:
                                          hasVariant(
                                            globalVariants,
                                            "locale",
                                            "spanish"
                                          )
                                      }
                                    )}
                                  >
                                    {hasVariant(
                                      globalVariants,
                                      "locale",
                                      "spanish"
                                    )
                                      ? "Nuevo ticket"
                                      : "New ticket"}
                                  </div>
                                }
                              >
                                {(() => {
                                  const child$Props = {
                                    className: classNames(
                                      "__wab_instance",
                                      sty.form,
                                      {
                                        [sty.formglobal_locale_spanish]:
                                          hasVariant(
                                            globalVariants,
                                            "locale",
                                            "spanish"
                                          )
                                      }
                                    ),
                                    extendedOnValuesChange: async (
                                      ...eventArgs: any
                                    ) => {
                                      generateStateOnChangePropForCodeComponents(
                                        $state,
                                        "value",
                                        ["form", "value"],
                                        FormWrapper_Helpers
                                      ).apply(null, eventArgs);
                                    },
                                    formItems: [
                                      {
                                        label: "Name",
                                        name: "name",
                                        inputType: "Text"
                                      },
                                      {
                                        label: "Message",
                                        name: "message",
                                        inputType: "Text Area"
                                      }
                                    ],
                                    initialValues: (() => {
                                      let a = JSON.parse(
                                        JSON.stringify(
                                          $state.faultyTicket ?? {}
                                        )
                                      );
                                      return a;
                                    })(),

                                    labelCol: { span: 8, horizontalOnly: true },
                                    layout: "vertical",
                                    mode: "advanced",
                                    onFinish: async values => {
                                      const $steps = {};

                                      $steps["invokeGlobalAction"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              args: [
                                                "table",
                                                "support_tickets",
                                                (() => {
                                                  let a = JSON.parse(
                                                    JSON.stringify(
                                                      $state.form.value
                                                    )
                                                  );
                                                  const p = a.priority;
                                                  a.priority = Array.isArray(p)
                                                    ? p[0]
                                                    : p;
                                                  a.status_id = 1;
                                                  a.resolution_notes = null;
                                                  return a;
                                                })(),

                                                $state.faultyTicket.ticket_id !=
                                                  undefined,
                                                true
                                              ]
                                            };
                                            return $globalActions[
                                              "SupabaseActions.create"
                                            ]?.apply(null, [
                                              ...actionArgs.args
                                            ]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["invokeGlobalAction"] != null &&
                                        typeof $steps["invokeGlobalAction"] ===
                                          "object" &&
                                        typeof $steps["invokeGlobalAction"]
                                          .then === "function"
                                      ) {
                                        $steps["invokeGlobalAction"] =
                                          await $steps["invokeGlobalAction"];
                                      }

                                      $steps["refreshData"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              queryInvalidation: [
                                                "plasmic_refresh_all"
                                              ]
                                            };
                                            return (async ({
                                              queryInvalidation
                                            }) => {
                                              if (!queryInvalidation) {
                                                return;
                                              }
                                              await plasmicInvalidate(
                                                queryInvalidation
                                              );
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["refreshData"] != null &&
                                        typeof $steps["refreshData"] ===
                                          "object" &&
                                        typeof $steps["refreshData"].then ===
                                          "function"
                                      ) {
                                        $steps["refreshData"] =
                                          await $steps["refreshData"];
                                      }

                                      $steps["runActionOnForm"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              tplRef: "form",
                                              action: "clearFields"
                                            };
                                            return (({
                                              tplRef,
                                              action,
                                              args
                                            }) => {
                                              return $refs?.[tplRef]?.[
                                                action
                                              ]?.(...(args ?? []));
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["runActionOnForm"] != null &&
                                        typeof $steps["runActionOnForm"] ===
                                          "object" &&
                                        typeof $steps["runActionOnForm"]
                                          .then === "function"
                                      ) {
                                        $steps["runActionOnForm"] =
                                          await $steps["runActionOnForm"];
                                      }

                                      $steps["updateTabsActiveKey"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              variable: {
                                                objRoot: $state,
                                                variablePath: [
                                                  "tabs",
                                                  "activeKey"
                                                ]
                                              },
                                              operation: 0,
                                              value: "2"
                                            };
                                            return (({
                                              variable,
                                              value,
                                              startIndex,
                                              deleteCount
                                            }) => {
                                              if (!variable) {
                                                return;
                                              }
                                              const { objRoot, variablePath } =
                                                variable;

                                              $stateSet(
                                                objRoot,
                                                variablePath,
                                                value
                                              );
                                              return value;
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["updateTabsActiveKey"] != null &&
                                        typeof $steps["updateTabsActiveKey"] ===
                                          "object" &&
                                        typeof $steps["updateTabsActiveKey"]
                                          .then === "function"
                                      ) {
                                        $steps["updateTabsActiveKey"] =
                                          await $steps["updateTabsActiveKey"];
                                      }
                                    },
                                    onIsSubmittingChange: async (
                                      ...eventArgs: any
                                    ) => {
                                      generateStateOnChangePropForCodeComponents(
                                        $state,
                                        "isSubmitting",
                                        ["form", "isSubmitting"],
                                        FormWrapper_Helpers
                                      ).apply(null, eventArgs);
                                    },
                                    ref: ref => {
                                      $refs["form"] = ref;
                                    },
                                    submitSlot: null,
                                    wrapperCol: {
                                      span: 16,
                                      horizontalOnly: true
                                    }
                                  };
                                  initializeCodeComponentStates(
                                    $state,
                                    [
                                      {
                                        name: "value",
                                        plasmicStateName: "form.value"
                                      },
                                      {
                                        name: "isSubmitting",
                                        plasmicStateName: "form.isSubmitting"
                                      }
                                    ],
                                    [],
                                    FormWrapper_Helpers ?? {},
                                    child$Props
                                  );

                                  return (
                                    <FormWrapper
                                      data-plasmic-name={"form"}
                                      data-plasmic-override={overrides.form}
                                      {...child$Props}
                                    >
                                      <SupabaseDataProvider
                                        alwaysClient={false}
                                        blockingLoad={false}
                                        className={classNames(
                                          "__wab_instance",
                                          sty.supabaseDataProviderTable__jpTtk
                                        )}
                                        match={
                                          "is_active=eq.true&name=not.ilike.*team*"
                                        }
                                        selectQuery={"value:id,label:name"}
                                        tableName={"technicians"}
                                      >
                                        <DataCtxReader__>
                                          {$ctx => (
                                            <FormItemWrapper
                                              className={classNames(
                                                "__wab_instance",
                                                sty.formField__zyYyj,
                                                {
                                                  [sty.formFieldglobal_locale_spanish__zyYyjjTbLa]:
                                                    hasVariant(
                                                      globalVariants,
                                                      "locale",
                                                      "spanish"
                                                    )
                                                }
                                              )}
                                              label={
                                                hasVariant(
                                                  globalVariants,
                                                  "locale",
                                                  "spanish"
                                                )
                                                  ? "Tu nombre"
                                                  : "Your name"
                                              }
                                              name={"created_by"}
                                              rules={[{ ruleType: "required" }]}
                                            >
                                              <AntdSelect
                                                data-plasmic-name={"select"}
                                                data-plasmic-override={
                                                  overrides.select
                                                }
                                                className={classNames(
                                                  "__wab_instance",
                                                  sty.select
                                                )}
                                                defaultStylesClassName={classNames(
                                                  "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                                                  "plasmic_default_styles",
                                                  "plasmic_mixins",
                                                  styleTokensClassNames
                                                )}
                                                onChange={async (
                                                  ...eventArgs: any
                                                ) => {
                                                  generateStateOnChangeProp(
                                                    $state,
                                                    ["select", "value"]
                                                  ).apply(null, eventArgs);
                                                }}
                                                options={(() => {
                                                  try {
                                                    return $ctx.technicians;
                                                  } catch (e) {
                                                    if (
                                                      e instanceof TypeError ||
                                                      e?.plasmicType ===
                                                        "PlasmicUndefinedDataError"
                                                    ) {
                                                      return [
                                                        {
                                                          value: "option1",
                                                          label: "Option 1",
                                                          type: "option"
                                                        },
                                                        {
                                                          value: "option2",
                                                          label: "Option 2",
                                                          type: "option"
                                                        }
                                                      ];
                                                    }
                                                    throw e;
                                                  }
                                                })()}
                                                placeholder={"Select..."}
                                                popupScopeClassName={
                                                  sty["select__popup"]
                                                }
                                                showSearch={true}
                                                value={generateStateValueProp(
                                                  $state,
                                                  ["select", "value"]
                                                )}
                                              />
                                            </FormItemWrapper>
                                          )}
                                        </DataCtxReader__>
                                      </SupabaseDataProvider>
                                      {(() => {
                                        try {
                                          return (
                                            $state.form.value?.created_by !=
                                            undefined
                                          );
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return false;
                                          }
                                          throw e;
                                        }
                                      })() ? (
                                        <FormItemWrapper
                                          className={classNames(
                                            "__wab_instance",
                                            sty.formField__qzFbM,
                                            {
                                              [sty.formFieldglobal_locale_spanish__qzFbMjTbLa]:
                                                hasVariant(
                                                  globalVariants,
                                                  "locale",
                                                  "spanish"
                                                )
                                            }
                                          )}
                                          label={
                                            hasVariant(
                                              globalVariants,
                                              "locale",
                                              "spanish"
                                            )
                                              ? "Prioridad"
                                              : "Priority"
                                          }
                                          name={"priority"}
                                          rules={[{ ruleType: "required" }]}
                                        >
                                          <Slider
                                            data-plasmic-name={"slider"}
                                            data-plasmic-override={
                                              overrides.slider
                                            }
                                            className={classNames(
                                              "__wab_instance",
                                              sty.slider,
                                              {
                                                [sty.sliderglobal_locale_spanish]:
                                                  hasVariant(
                                                    globalVariants,
                                                    "locale",
                                                    "spanish"
                                                  )
                                              }
                                            )}
                                            maxValue={10}
                                            onChange={async (
                                              ...eventArgs: any
                                            ) => {
                                              generateStateOnChangeProp(
                                                $state,
                                                ["slider", "value"]
                                              ).apply(null, eventArgs);

                                              if (
                                                eventArgs.length > 1 &&
                                                eventArgs[1] &&
                                                eventArgs[1]
                                                  ._plasmic_state_init_
                                              ) {
                                                return;
                                              }
                                            }}
                                            showLabel={false}
                                            value={generateStateValueProp(
                                              $state,
                                              ["slider", "value"]
                                            )}
                                          />
                                        </FormItemWrapper>
                                      ) : null}
                                      {(() => {
                                        try {
                                          return (
                                            $state.form.value?.priority !=
                                            undefined
                                          );
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return false;
                                          }
                                          throw e;
                                        }
                                      })() ? (
                                        <FormItemWrapper
                                          className={classNames(
                                            "__wab_instance",
                                            sty.formField___5P4Ya,
                                            {
                                              [sty.formFieldglobal_locale_spanish___5P4YAjTbLa]:
                                                hasVariant(
                                                  globalVariants,
                                                  "locale",
                                                  "spanish"
                                                )
                                            }
                                          )}
                                          label={
                                            hasVariant(
                                              globalVariants,
                                              "locale",
                                              "spanish"
                                            )
                                              ? "Categoria"
                                              : "Category"
                                          }
                                          name={"category"}
                                          rules={[{ ruleType: "required" }]}
                                        >
                                          <AntdSelect
                                            data-plasmic-name={"select2"}
                                            data-plasmic-override={
                                              overrides.select2
                                            }
                                            className={classNames(
                                              "__wab_instance",
                                              sty.select2,
                                              {
                                                [sty.select2global_locale_spanish]:
                                                  hasVariant(
                                                    globalVariants,
                                                    "locale",
                                                    "spanish"
                                                  )
                                              }
                                            )}
                                            defaultStylesClassName={classNames(
                                              "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                                              "plasmic_default_styles",
                                              "plasmic_mixins",
                                              styleTokensClassNames
                                            )}
                                            onChange={async (
                                              ...eventArgs: any
                                            ) => {
                                              generateStateOnChangeProp(
                                                $state,
                                                ["select2", "value"]
                                              ).apply(null, eventArgs);
                                            }}
                                            options={
                                              hasVariant(
                                                globalVariants,
                                                "locale",
                                                "spanish"
                                              )
                                                ? (() => {
                                                    const __composite = [
                                                      {
                                                        value: null,
                                                        label: null,
                                                        type: "option"
                                                      },
                                                      {
                                                        value: null,
                                                        label: null,
                                                        type: "option"
                                                      },
                                                      {
                                                        type: "option",
                                                        value: null,
                                                        label: null
                                                      }
                                                    ];
                                                    __composite["0"]["value"] =
                                                      "hardware";
                                                    __composite["0"]["label"] =
                                                      "Fisico";
                                                    __composite["1"]["value"] =
                                                      "software";
                                                    __composite["1"]["label"] =
                                                      "Programas";
                                                    __composite["2"]["value"] =
                                                      "feature_request";
                                                    __composite["2"]["label"] =
                                                      "Pedir nueva funcion";
                                                    return __composite;
                                                  })()
                                                : (() => {
                                                    const __composite = [
                                                      {
                                                        value: null,
                                                        label: null,
                                                        type: "option"
                                                      },
                                                      {
                                                        value: null,
                                                        label: null,
                                                        type: "option"
                                                      },
                                                      {
                                                        type: "option",
                                                        value: null,
                                                        label: null
                                                      }
                                                    ];
                                                    __composite["0"]["value"] =
                                                      "hardware";
                                                    __composite["0"]["label"] =
                                                      "Hardware";
                                                    __composite["1"]["value"] =
                                                      "software";
                                                    __composite["1"]["label"] =
                                                      "Software";
                                                    __composite["2"]["value"] =
                                                      "feature_request";
                                                    __composite["2"]["label"] =
                                                      "Feature Request";
                                                    return __composite;
                                                  })()
                                            }
                                            placeholder={"Select..."}
                                            popupScopeClassName={
                                              sty["select2__popup"]
                                            }
                                            value={generateStateValueProp(
                                              $state,
                                              ["select2", "value"]
                                            )}
                                          />
                                        </FormItemWrapper>
                                      ) : null}
                                      <FormItemWrapper
                                        className={classNames(
                                          "__wab_instance",
                                          sty.formField__nFv2S,
                                          {
                                            [sty.formFieldglobal_locale_spanish__nFv2SjTbLa]:
                                              hasVariant(
                                                globalVariants,
                                                "locale",
                                                "spanish"
                                              )
                                          }
                                        )}
                                        hidden={
                                          $state.form.value?.category !=
                                          "software"
                                        }
                                        label={
                                          <div
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.text__kkluY,
                                              {
                                                [sty.textglobal_locale_spanish__kkluYjTbLa]:
                                                  hasVariant(
                                                    globalVariants,
                                                    "locale",
                                                    "spanish"
                                                  )
                                              }
                                            )}
                                          >
                                            {hasVariant(
                                              globalVariants,
                                              "locale",
                                              "spanish"
                                            )
                                              ? "Culpa"
                                              : "Subcategory"}
                                          </div>
                                        }
                                        name={"subcategory"}
                                      >
                                        <AntdSelect
                                          data-plasmic-name={"select3"}
                                          data-plasmic-override={
                                            overrides.select3
                                          }
                                          className={classNames(
                                            "__wab_instance",
                                            sty.select3,
                                            {
                                              [sty.select3global_locale_spanish]:
                                                hasVariant(
                                                  globalVariants,
                                                  "locale",
                                                  "spanish"
                                                )
                                            }
                                          )}
                                          defaultStylesClassName={classNames(
                                            "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                                            "plasmic_default_styles",
                                            "plasmic_mixins",
                                            styleTokensClassNames
                                          )}
                                          onChange={async (
                                            ...eventArgs: any
                                          ) => {
                                            generateStateOnChangeProp($state, [
                                              "select3",
                                              "value"
                                            ]).apply(null, eventArgs);
                                          }}
                                          options={
                                            hasVariant(
                                              globalVariants,
                                              "locale",
                                              "spanish"
                                            )
                                              ? (() => {
                                                  const __composite = [
                                                    {
                                                      value: null,
                                                      label: null,
                                                      type: "option"
                                                    },
                                                    {
                                                      value: null,
                                                      label: null,
                                                      type: "option"
                                                    }
                                                  ];
                                                  __composite["0"]["value"] =
                                                    "legit_issue";
                                                  __composite["0"]["label"] =
                                                    "Del sistema";
                                                  __composite["1"]["value"] =
                                                    "user_error";
                                                  __composite["1"]["label"] =
                                                    "Tuya";
                                                  return __composite;
                                                })()
                                              : (() => {
                                                  const __composite = [
                                                    {
                                                      value: null,
                                                      label: null,
                                                      type: "option"
                                                    },
                                                    {
                                                      value: null,
                                                      label: null,
                                                      type: "option"
                                                    }
                                                  ];
                                                  __composite["0"]["value"] =
                                                    "legit_issue";
                                                  __composite["0"]["label"] =
                                                    "System error";
                                                  __composite["1"]["value"] =
                                                    "user_error";
                                                  __composite["1"]["label"] =
                                                    "You error";
                                                  return __composite;
                                                })()
                                          }
                                          placeholder={"Select..."}
                                          popupScopeClassName={
                                            sty["select3__popup"]
                                          }
                                          value={generateStateValueProp(
                                            $state,
                                            ["select3", "value"]
                                          )}
                                        />
                                      </FormItemWrapper>
                                      <FormItemWrapper
                                        className={classNames(
                                          "__wab_instance",
                                          sty.formField__sKaVl,
                                          {
                                            [sty.formFieldglobal_locale_spanish__sKaVljTbLa]:
                                              hasVariant(
                                                globalVariants,
                                                "locale",
                                                "spanish"
                                              )
                                          }
                                        )}
                                        hidden={
                                          $state.form.value?.subcategory !=
                                          "legit_issue"
                                        }
                                        label={
                                          hasVariant(
                                            globalVariants,
                                            "locale",
                                            "spanish"
                                          )
                                            ? "Que error dice el sistema?"
                                            : "Error code"
                                        }
                                        name={"description"}
                                      >
                                        {(() => {
                                          const child$Props = {
                                            autoSize: false,
                                            className: classNames(
                                              "__wab_instance",
                                              sty.textArea3
                                            ),
                                            onChange: async (
                                              ...eventArgs: any
                                            ) => {
                                              generateStateOnChangePropForCodeComponents(
                                                $state,
                                                "value",
                                                ["textArea3", "value"],
                                                AntdTextArea_Helpers
                                              ).apply(null, eventArgs);
                                            },
                                            placeholder:
                                              "Duplicate IMEIs found: {356321742427776}",
                                            value: generateStateValueProp(
                                              $state,
                                              ["textArea3", "value"]
                                            )
                                          };
                                          initializeCodeComponentStates(
                                            $state,
                                            [
                                              {
                                                name: "value",
                                                plasmicStateName:
                                                  "textArea3.value"
                                              }
                                            ],
                                            [],
                                            AntdTextArea_Helpers ?? {},
                                            child$Props
                                          );

                                          return (
                                            <AntdTextArea
                                              data-plasmic-name={"textArea3"}
                                              data-plasmic-override={
                                                overrides.textArea3
                                              }
                                              {...child$Props}
                                            />
                                          );
                                        })()}
                                      </FormItemWrapper>
                                      <FormItemWrapper
                                        className={classNames(
                                          "__wab_instance",
                                          sty.formField__hK7Q,
                                          {
                                            [sty.formFieldglobal_locale_spanish__hK7QjTbLa]:
                                              hasVariant(
                                                globalVariants,
                                                "locale",
                                                "spanish"
                                              )
                                          }
                                        )}
                                        hidden={
                                          $state.form.value?.subcategory !=
                                          "user_error"
                                        }
                                        label={
                                          hasVariant(
                                            globalVariants,
                                            "locale",
                                            "spanish"
                                          )
                                            ? "Que hiciste mal?"
                                            : "What did you do?"
                                        }
                                        name={"user_error_details"}
                                        rules={[
                                          {
                                            ruleType: "min",
                                            length: 20,
                                            message: "Too short"
                                          }
                                        ]}
                                      >
                                        {(() => {
                                          const child$Props = {
                                            autoSize: true,
                                            className: classNames(
                                              "__wab_instance",
                                              sty.textArea4
                                            ),
                                            onChange: async (
                                              ...eventArgs: any
                                            ) => {
                                              generateStateOnChangePropForCodeComponents(
                                                $state,
                                                "value",
                                                ["textArea4", "value"],
                                                AntdTextArea_Helpers
                                              ).apply(null, eventArgs);
                                            },
                                            placeholder:
                                              "Cree err\u00f3neamente un reporte",
                                            value: generateStateValueProp(
                                              $state,
                                              ["textArea4", "value"]
                                            )
                                          };
                                          initializeCodeComponentStates(
                                            $state,
                                            [
                                              {
                                                name: "value",
                                                plasmicStateName:
                                                  "textArea4.value"
                                              }
                                            ],
                                            [],
                                            AntdTextArea_Helpers ?? {},
                                            child$Props
                                          );

                                          return (
                                            <AntdTextArea
                                              data-plasmic-name={"textArea4"}
                                              data-plasmic-override={
                                                overrides.textArea4
                                              }
                                              {...child$Props}
                                            />
                                          );
                                        })()}
                                      </FormItemWrapper>
                                      {(() => {
                                        try {
                                          return (
                                            typeof $state.form.value
                                              ?.category != "undefined"
                                          );
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return false;
                                          }
                                          throw e;
                                        }
                                      })() ? (
                                        <FormItemWrapper
                                          className={classNames(
                                            "__wab_instance",
                                            sty.formField__fom9S,
                                            {
                                              [sty.formFieldglobal_locale_spanish__fom9SjTbLa]:
                                                hasVariant(
                                                  globalVariants,
                                                  "locale",
                                                  "spanish"
                                                )
                                            }
                                          )}
                                          label={
                                            hasVariant(
                                              globalVariants,
                                              "locale",
                                              "spanish"
                                            )
                                              ? "Que quieres que pase?"
                                              : "What do you want?"
                                          }
                                          name={"title"}
                                          rules={[{ ruleType: "required" }]}
                                        >
                                          {(() => {
                                            const child$Props = {
                                              autoSize: true,
                                              className: classNames(
                                                "__wab_instance",
                                                sty.textArea5,
                                                {
                                                  [sty.textArea5global_locale_spanish]:
                                                    hasVariant(
                                                      globalVariants,
                                                      "locale",
                                                      "spanish"
                                                    )
                                                }
                                              ),
                                              onChange: async (
                                                ...eventArgs: any
                                              ) => {
                                                generateStateOnChangePropForCodeComponents(
                                                  $state,
                                                  "value",
                                                  ["textArea5", "value"],
                                                  AntdTextArea_Helpers
                                                ).apply(null, eventArgs);
                                              },
                                              placeholder:
                                                "Borrar el reporte del telefono ID 323934",
                                              value: generateStateValueProp(
                                                $state,
                                                ["textArea5", "value"]
                                              )
                                            };
                                            initializeCodeComponentStates(
                                              $state,
                                              [
                                                {
                                                  name: "value",
                                                  plasmicStateName:
                                                    "textArea5.value"
                                                }
                                              ],
                                              [],
                                              AntdTextArea_Helpers ?? {},
                                              child$Props
                                            );

                                            return (
                                              <AntdTextArea
                                                data-plasmic-name={"textArea5"}
                                                data-plasmic-override={
                                                  overrides.textArea5
                                                }
                                                {...child$Props}
                                              />
                                            );
                                          })()}
                                        </FormItemWrapper>
                                      ) : null}
                                      {(() => {
                                        try {
                                          return (
                                            $state.form.value?.title !=
                                            undefined
                                          );
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return false;
                                          }
                                          throw e;
                                        }
                                      })() ? (
                                        <FormItemWrapper
                                          className={classNames(
                                            "__wab_instance",
                                            sty.formField__qzKiN,
                                            {
                                              [sty.formFieldglobal_locale_spanish__qzKiNjTbLa]:
                                                hasVariant(
                                                  globalVariants,
                                                  "locale",
                                                  "spanish"
                                                )
                                            }
                                          )}
                                          hidden={
                                            $state.form.value?.subcategory !=
                                            "user_error"
                                          }
                                          label={
                                            hasVariant(
                                              globalVariants,
                                              "locale",
                                              "spanish"
                                            )
                                              ? "Porque cometiste ese error?"
                                              : "Why did you do that mistake?"
                                          }
                                          name={"description"}
                                        >
                                          {(() => {
                                            const child$Props = {
                                              autoSize: true,
                                              className: classNames(
                                                "__wab_instance",
                                                sty.textArea2
                                              ),
                                              onChange: async (
                                                ...eventArgs: any
                                              ) => {
                                                generateStateOnChangePropForCodeComponents(
                                                  $state,
                                                  "value",
                                                  ["textArea2", "value"],
                                                  AntdTextArea_Helpers
                                                ).apply(null, eventArgs);
                                              },
                                              placeholder:
                                                "Porque no pregunte bien antes de hacer el reporte",
                                              value: generateStateValueProp(
                                                $state,
                                                ["textArea2", "value"]
                                              )
                                            };
                                            initializeCodeComponentStates(
                                              $state,
                                              [
                                                {
                                                  name: "value",
                                                  plasmicStateName:
                                                    "textArea2.value"
                                                }
                                              ],
                                              [],
                                              AntdTextArea_Helpers ?? {},
                                              child$Props
                                            );

                                            return (
                                              <AntdTextArea
                                                data-plasmic-name={"textArea2"}
                                                data-plasmic-override={
                                                  overrides.textArea2
                                                }
                                                {...child$Props}
                                              />
                                            );
                                          })()}
                                        </FormItemWrapper>
                                      ) : null}
                                      <AntdButton
                                        className={classNames(
                                          "__wab_instance",
                                          sty.button__pKpNz
                                        )}
                                        submitsForm={true}
                                        type={"primary"}
                                      >
                                        <div
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text__elwXb
                                          )}
                                        >
                                          {"Submit"}
                                        </div>
                                      </AntdButton>
                                    </FormWrapper>
                                  );
                                })()}
                              </AntdTabItem>
                              <AntdTabItem
                                className={classNames(
                                  "__wab_instance",
                                  sty.tabItem__gsPV
                                )}
                                key={"2"}
                                label={
                                  <div
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.text__sgoL,
                                      {
                                        [sty.textglobal_locale_spanish__sgoLjTbLa]:
                                          hasVariant(
                                            globalVariants,
                                            "locale",
                                            "spanish"
                                          )
                                      }
                                    )}
                                  >
                                    {hasVariant(
                                      globalVariants,
                                      "locale",
                                      "spanish"
                                    )
                                      ? "Tus tickets"
                                      : "Current tickets"}
                                  </div>
                                }
                              >
                                <div
                                  className={classNames(
                                    "all",
                                    sty.freeBox___0AIyL
                                  )}
                                >
                                  <AntdSegmented
                                    data-plasmic-name={"segmented"}
                                    data-plasmic-override={overrides.segmented}
                                    className={classNames(
                                      "__wab_instance",
                                      sty.segmented,
                                      {
                                        [sty.segmentedglobal_locale_spanish]:
                                          hasVariant(
                                            globalVariants,
                                            "locale",
                                            "spanish"
                                          )
                                      }
                                    )}
                                    defaultValue={"1"}
                                    onChange={async (...eventArgs: any) => {
                                      generateStateOnChangeProp($state, [
                                        "segmented",
                                        "value"
                                      ]).apply(null, eventArgs);
                                    }}
                                    options={
                                      hasVariant(
                                        globalVariants,
                                        "locale",
                                        "spanish"
                                      )
                                        ? (() => {
                                            const __composite = [
                                              { label: null, value: null },
                                              { label: null, value: null }
                                            ];
                                            __composite["0"]["label"] =
                                              "Actual";
                                            __composite["0"]["value"] = "1";
                                            __composite["1"]["label"] =
                                              "Cerrado";
                                            __composite["1"]["value"] = "4";
                                            return __composite;
                                          })()
                                        : (() => {
                                            const __composite = [
                                              { label: null, value: null },
                                              { label: null, value: null }
                                            ];
                                            __composite["0"]["label"] =
                                              "Current";
                                            __composite["0"]["value"] = "1";
                                            __composite["1"]["label"] =
                                              "Closed";
                                            __composite["1"]["value"] = "4";
                                            return __composite;
                                          })()
                                    }
                                    optionsSlot={
                                      <React.Fragment>
                                        <AntdSegmentedOption
                                          className={classNames(
                                            "__wab_instance",
                                            sty.segmentedOption__cYyH2
                                          )}
                                          value={"Option 1"}
                                        >
                                          <div
                                            className={classNames(
                                              "all",
                                              sty.freeBox__ub18Y
                                            )}
                                          >
                                            <PlasmicImg__
                                              alt={""}
                                              className={classNames(
                                                sty.img__zgWgY
                                              )}
                                              displayHeight={"auto"}
                                              displayMaxHeight={"none"}
                                              displayMaxWidth={"none"}
                                              displayMinHeight={"0"}
                                              displayMinWidth={"0"}
                                              displayWidth={"auto"}
                                              src={
                                                "/plasmic/inventory/images/home-outlined.svg"
                                              }
                                            />

                                            <div
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text__iCdl
                                              )}
                                            >
                                              {"Option 1"}
                                            </div>
                                          </div>
                                        </AntdSegmentedOption>
                                        <AntdSegmentedOption
                                          className={classNames(
                                            "__wab_instance",
                                            sty.segmentedOption__txlEp
                                          )}
                                          value={"Option 2"}
                                        >
                                          <div
                                            className={classNames(
                                              "all",
                                              sty.freeBox__h0HQu
                                            )}
                                          >
                                            <PlasmicImg__
                                              alt={""}
                                              className={classNames(
                                                sty.img___6Rd8
                                              )}
                                              displayHeight={"auto"}
                                              displayMaxHeight={"none"}
                                              displayMaxWidth={"none"}
                                              displayMinHeight={"0"}
                                              displayMinWidth={"0"}
                                              displayWidth={"auto"}
                                              src={
                                                "/plasmic/inventory/images/home-outlined.svg"
                                              }
                                            />

                                            <div
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text__hoR1Q
                                              )}
                                            >
                                              {"Option 2"}
                                            </div>
                                          </div>
                                        </AntdSegmentedOption>
                                      </React.Fragment>
                                    }
                                    useSlotOptions={false}
                                    value={generateStateValueProp($state, [
                                      "segmented",
                                      "value"
                                    ])}
                                  />

                                  {(_par =>
                                    !_par
                                      ? []
                                      : Array.isArray(_par)
                                        ? _par
                                        : [_par])(
                                    (() => {
                                      try {
                                        return (() => {
                                          if ($state.segmented.value == 1) {
                                            return $ctx.support_tickets.filter(
                                              item => item.status_id != 5
                                            );
                                          } else {
                                            return $ctx.support_tickets.filter(
                                              item => item.status_id == 5
                                            );
                                          }
                                        })();
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return [];
                                        }
                                        throw e;
                                      }
                                    })()
                                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                                    const currentItem = __plasmic_item_0;
                                    const currentIndex = __plasmic_idx_0;
                                    return (
                                      <div
                                        className={classNames(
                                          "all",
                                          sty.freeBox__cM4Il
                                        )}
                                        key={currentIndex}
                                      >
                                        <div
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text___9H6H6
                                          )}
                                        >
                                          <React.Fragment>
                                            {currentItem.title}
                                          </React.Fragment>
                                        </div>
                                        {(() => {
                                          const child$Props = {
                                            className: classNames(
                                              "__wab_instance",
                                              sty.steps,
                                              {
                                                [sty.stepsglobal_locale_spanish]:
                                                  hasVariant(
                                                    globalVariants,
                                                    "locale",
                                                    "spanish"
                                                  )
                                              }
                                            ),
                                            current: generateStateValueProp(
                                              $state,
                                              [
                                                "steps",
                                                __plasmic_idx_0,
                                                "current"
                                              ]
                                            ),
                                            items: (() => {
                                              const __composite = [
                                                { title: null },
                                                { title: null },
                                                {
                                                  title: null,
                                                  description: null
                                                }
                                              ];
                                              __composite["0"]["title"] =
                                                "Waiting";
                                              __composite["1"]["title"] =
                                                "Checking";
                                              __composite["2"]["title"] =
                                                currentItem.status_id == 11
                                                  ? "Denied"
                                                  : "Complete";
                                              __composite["2"]["description"] =
                                                currentItem.resolution_notes;
                                              return __composite;
                                            })(),

                                            onChange: async (
                                              ...eventArgs: any
                                            ) => {
                                              generateStateOnChangeProp(
                                                $state,
                                                [
                                                  "steps",
                                                  __plasmic_idx_0,
                                                  "current"
                                                ]
                                              ).apply(null, eventArgs);
                                            },
                                            status:
                                              currentItem.status_id == 11
                                                ? "error"
                                                : currentItem.status_id == 5
                                                  ? "finish"
                                                  : "process"
                                          };
                                          initializeCodeComponentStates(
                                            $state,
                                            [
                                              {
                                                name: "current",
                                                plasmicStateName:
                                                  "steps[].current"
                                              }
                                            ],
                                            [__plasmic_idx_0],
                                            undefined ?? {},
                                            child$Props
                                          );
                                          initializePlasmicStates(
                                            $state,
                                            [
                                              {
                                                name: "steps[].current",
                                                initFunc: ({
                                                  $props,
                                                  $state,
                                                  $queries,
                                                  $q
                                                }) =>
                                                  (() => {
                                                    try {
                                                      return (() => {
                                                        let a = {
                                                          1: 0,
                                                          8: 1,
                                                          11: 2,
                                                          4: 2,
                                                          5: 2
                                                        };
                                                        return a[
                                                          currentItem.status_id
                                                        ];
                                                      })();
                                                    } catch (e) {
                                                      if (
                                                        e instanceof
                                                          TypeError ||
                                                        e?.plasmicType ===
                                                          "PlasmicUndefinedDataError"
                                                      ) {
                                                        return 0;
                                                      }
                                                      throw e;
                                                    }
                                                  })()
                                              }
                                            ],
                                            [__plasmic_idx_0]
                                          );
                                          return (
                                            <AntdSteps
                                              data-plasmic-name={"steps"}
                                              data-plasmic-override={
                                                overrides.steps
                                              }
                                              {...child$Props}
                                            />
                                          );
                                        })()}
                                        <div
                                          className={classNames(
                                            "all",
                                            sty.freeBox__lRlrj,
                                            {
                                              [sty.freeBoxglobal_locale_spanish__lRlrjjTbLa]:
                                                hasVariant(
                                                  globalVariants,
                                                  "locale",
                                                  "spanish"
                                                )
                                            }
                                          )}
                                        >
                                          {(() => {
                                            try {
                                              return currentItem.status_id == 4;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return true;
                                              }
                                              throw e;
                                            }
                                          })() ? (
                                            <AntdButton
                                              className={classNames(
                                                "__wab_instance",
                                                sty.button___2Mku,
                                                {
                                                  [sty.buttonglobal_locale_spanish___2MkuJTbLa]:
                                                    hasVariant(
                                                      globalVariants,
                                                      "locale",
                                                      "spanish"
                                                    )
                                                }
                                              )}
                                              onClick={async () => {
                                                const $steps = {};

                                                $steps["invokeGlobalAction"] =
                                                  true
                                                    ? (() => {
                                                        const actionArgs = {
                                                          args: [
                                                            "support_tickets",
                                                            {
                                                              eq: {
                                                                ticket_id:
                                                                  currentItem.ticket_id
                                                              }
                                                            },

                                                            {
                                                              status_id: 5
                                                            },
                                                            true
                                                          ]
                                                        };
                                                        return $globalActions[
                                                          "SupabaseActions.update"
                                                        ]?.apply(null, [
                                                          ...actionArgs.args
                                                        ]);
                                                      })()
                                                    : undefined;
                                                if (
                                                  $steps[
                                                    "invokeGlobalAction"
                                                  ] != null &&
                                                  typeof $steps[
                                                    "invokeGlobalAction"
                                                  ] === "object" &&
                                                  typeof $steps[
                                                    "invokeGlobalAction"
                                                  ].then === "function"
                                                ) {
                                                  $steps["invokeGlobalAction"] =
                                                    await $steps[
                                                      "invokeGlobalAction"
                                                    ];
                                                }

                                                $steps["refreshData"] = true
                                                  ? (() => {
                                                      const actionArgs = {
                                                        queryInvalidation: [
                                                          "plasmic_refresh_all"
                                                        ]
                                                      };
                                                      return (async ({
                                                        queryInvalidation
                                                      }) => {
                                                        if (
                                                          !queryInvalidation
                                                        ) {
                                                          return;
                                                        }
                                                        await plasmicInvalidate(
                                                          queryInvalidation
                                                        );
                                                      })?.apply(null, [
                                                        actionArgs
                                                      ]);
                                                    })()
                                                  : undefined;
                                                if (
                                                  $steps["refreshData"] !=
                                                    null &&
                                                  typeof $steps[
                                                    "refreshData"
                                                  ] === "object" &&
                                                  typeof $steps["refreshData"]
                                                    .then === "function"
                                                ) {
                                                  $steps["refreshData"] =
                                                    await $steps["refreshData"];
                                                }
                                              }}
                                              type={"primary"}
                                            >
                                              <div
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.text__htmk7,
                                                  {
                                                    [sty.textglobal_locale_spanish__htmk7JTbLa]:
                                                      hasVariant(
                                                        globalVariants,
                                                        "locale",
                                                        "spanish"
                                                      )
                                                  }
                                                )}
                                              >
                                                {hasVariant(
                                                  globalVariants,
                                                  "locale",
                                                  "spanish"
                                                )
                                                  ? "Todo esta bien"
                                                  : "Close"}
                                              </div>
                                            </AntdButton>
                                          ) : null}
                                          {(() => {
                                            try {
                                              return (
                                                currentItem.status_id == 11 ||
                                                currentItem.status_id == 4
                                              );
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return false;
                                              }
                                              throw e;
                                            }
                                          })() ? (
                                            <AntdButton
                                              className={classNames(
                                                "__wab_instance",
                                                sty.button__aPq7
                                              )}
                                              danger={false}
                                              onClick={async () => {
                                                const $steps = {};

                                                $steps["updateTabsActiveKey"] =
                                                  true
                                                    ? (() => {
                                                        const actionArgs = {
                                                          variable: {
                                                            objRoot: $state,
                                                            variablePath: [
                                                              "tabs",
                                                              "activeKey"
                                                            ]
                                                          },
                                                          operation: 0,
                                                          value: "1"
                                                        };
                                                        return (({
                                                          variable,
                                                          value,
                                                          startIndex,
                                                          deleteCount
                                                        }) => {
                                                          if (!variable) {
                                                            return;
                                                          }
                                                          const {
                                                            objRoot,
                                                            variablePath
                                                          } = variable;

                                                          $stateSet(
                                                            objRoot,
                                                            variablePath,
                                                            value
                                                          );
                                                          return value;
                                                        })?.apply(null, [
                                                          actionArgs
                                                        ]);
                                                      })()
                                                    : undefined;
                                                if (
                                                  $steps[
                                                    "updateTabsActiveKey"
                                                  ] != null &&
                                                  typeof $steps[
                                                    "updateTabsActiveKey"
                                                  ] === "object" &&
                                                  typeof $steps[
                                                    "updateTabsActiveKey"
                                                  ].then === "function"
                                                ) {
                                                  $steps[
                                                    "updateTabsActiveKey"
                                                  ] =
                                                    await $steps[
                                                      "updateTabsActiveKey"
                                                    ];
                                                }

                                                $steps["updateFaultyTicket"] =
                                                  true
                                                    ? (() => {
                                                        const actionArgs = {
                                                          variable: {
                                                            objRoot: $state,
                                                            variablePath: [
                                                              "faultyTicket"
                                                            ]
                                                          },
                                                          operation: 0,
                                                          value: currentItem
                                                        };
                                                        return (({
                                                          variable,
                                                          value,
                                                          startIndex,
                                                          deleteCount
                                                        }) => {
                                                          if (!variable) {
                                                            return;
                                                          }
                                                          const {
                                                            objRoot,
                                                            variablePath
                                                          } = variable;

                                                          $stateSet(
                                                            objRoot,
                                                            variablePath,
                                                            value
                                                          );
                                                          return value;
                                                        })?.apply(null, [
                                                          actionArgs
                                                        ]);
                                                      })()
                                                    : undefined;
                                                if (
                                                  $steps[
                                                    "updateFaultyTicket"
                                                  ] != null &&
                                                  typeof $steps[
                                                    "updateFaultyTicket"
                                                  ] === "object" &&
                                                  typeof $steps[
                                                    "updateFaultyTicket"
                                                  ].then === "function"
                                                ) {
                                                  $steps["updateFaultyTicket"] =
                                                    await $steps[
                                                      "updateFaultyTicket"
                                                    ];
                                                }
                                              }}
                                              type={"primary"}
                                            >
                                              <div
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.text__tQuq0,
                                                  {
                                                    [sty.textglobal_locale_spanish__tQuq0JTbLa]:
                                                      hasVariant(
                                                        globalVariants,
                                                        "locale",
                                                        "spanish"
                                                      )
                                                  }
                                                )}
                                              >
                                                {hasVariant(
                                                  globalVariants,
                                                  "locale",
                                                  "spanish"
                                                )
                                                  ? "Arreglar"
                                                  : "Modify ticket"}
                                              </div>
                                            </AntdButton>
                                          ) : null}
                                        </div>
                                        <Embed
                                          data-plasmic-name={"embedHtml"}
                                          data-plasmic-override={
                                            overrides.embedHtml
                                          }
                                          className={classNames(
                                            "__wab_instance",
                                            sty.embedHtml
                                          )}
                                          code={(() => {
                                            try {
                                              return currentItem.html_feedback;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return "<div>Paste your embed code via the right sidebar</div>";
                                              }
                                              throw e;
                                            }
                                          })()}
                                        />
                                      </div>
                                    );
                                  })}
                                </div>
                              </AntdTabItem>
                            </React.Fragment>
                          }
                          onChange={async (...eventArgs: any) => {
                            generateStateOnChangeProp($state, [
                              "tabs",
                              "activeKey"
                            ]).apply(null, eventArgs);
                          }}
                          sticky={false}
                          tabBarBackground={"#FFF"}
                          tabPosition={"top"}
                          tabsDropdownScopeClassName={sty["tabs__tabsDropdown"]}
                          tabsScopeClassName={sty["tabs__tabs"]}
                        />
                      </AntdModal>
                    );
                  })()}
                </React.Fragment>
              )}
            </DataCtxReader__>
          </SupabaseDataProvider>
        </div>
      ) : null}
      {(() => {
        try {
          return $ctx.layout.id == 5;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div className={classNames("all", sty.freeBox___50F2Q)}>
          <SupabaseDataProvider
            alwaysClient={false}
            blockingLoad={false}
            className={classNames(
              "__wab_instance",
              sty.supabaseDataProviderTable___6MR
            )}
            selectQuery={
              "ticket_id,created_at,updated_at,category,priority,title,description,resolution_notes,subcategory,user_error_details,status_id,...enum_status(status:name),created_by_tech:technicians!support_tickets_created_by_fkey(created_by:name),created_by_account_tech:technicians!support_tickets_updater_id_fkey(name),html_feedback"
            }
            tableName={"support_tickets"}
          >
            <DataCtxReader__>
              {$ctx => (
                <React.Fragment>
                  <div
                    className={classNames("all", sty.freeBox___1Prf8)}
                    onClick={async event => {
                      const $steps = {};

                      $steps["updateModalOpen"] = true
                        ? (() => {
                            const actionArgs = {
                              variable: {
                                objRoot: $state,
                                variablePath: ["modal2", "open"]
                              },
                              operation: 0,
                              value: true
                            };
                            return (({
                              variable,
                              value,
                              startIndex,
                              deleteCount
                            }) => {
                              if (!variable) {
                                return;
                              }
                              const { objRoot, variablePath } = variable;

                              $stateSet(objRoot, variablePath, value);
                              return value;
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["updateModalOpen"] != null &&
                        typeof $steps["updateModalOpen"] === "object" &&
                        typeof $steps["updateModalOpen"].then === "function"
                      ) {
                        $steps["updateModalOpen"] =
                          await $steps["updateModalOpen"];
                      }
                    }}
                  >
                    <SignatureSvgIcon
                      className={classNames("all", sty.svg__dHkn)}
                      role={"img"}
                    />
                  </div>
                  {(() => {
                    const child$Props = {
                      className: classNames("__wab_instance", sty.modal2),
                      defaultStylesClassName: classNames(
                        "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                        "plasmic_default_styles",
                        "plasmic_mixins",
                        styleTokensClassNames
                      ),
                      hideFooter: true,
                      modalScopeClassName: sty["modal2__modal"],
                      onOpenChange: async (...eventArgs: any) => {
                        generateStateOnChangeProp($state, [
                          "modal2",
                          "open"
                        ]).apply(null, eventArgs);
                      },
                      open: generateStateValueProp($state, ["modal2", "open"]),
                      title: "Manage tickets",
                      trigger: null,
                      width: hasVariant(globalVariants, "screen", "mobileOnly")
                        ? "100%"
                        : "70%",
                      wrapClassName: classNames({
                        [sty["pcls_RtLYQ3wmls67"]]: true
                      })
                    };
                    initializeCodeComponentStates(
                      $state,
                      [
                        {
                          name: "open",
                          plasmicStateName: "modal2.open"
                        }
                      ],
                      [],
                      undefined ?? {},
                      child$Props
                    );
                    initializePlasmicStates(
                      $state,
                      [
                        {
                          name: "modal2.open",
                          initFunc: ({ $props, $state, $queries, $q }) =>
                            $ctx.support_tickets
                              ?.map(
                                item => ![4, 11, 5].includes(item.status_id)
                              )
                              .some(Boolean)
                        }
                      ],
                      []
                    );
                    return (
                      <AntdModal
                        data-plasmic-name={"modal2"}
                        data-plasmic-override={overrides.modal2}
                        {...child$Props}
                      >
                        <div className={classNames("all", sty.freeBox__ncGO)}>
                          <AntdSegmented
                            data-plasmic-name={"segmented2"}
                            data-plasmic-override={overrides.segmented2}
                            className={classNames(
                              "__wab_instance",
                              sty.segmented2
                            )}
                            defaultValue={1}
                            onChange={async (...eventArgs: any) => {
                              generateStateOnChangeProp($state, [
                                "segmented2",
                                "value"
                              ]).apply(null, eventArgs);
                            }}
                            options={(() => {
                              try {
                                return (() => {
                                  let b = Array.from(
                                    new Map(
                                      ($ctx?.support_tickets ?? [])
                                        .filter(item => item?.status_id != null)
                                        .map(item => [
                                          item.status_id,
                                          {
                                            label: item.status ?? "",
                                            value: item.status_id
                                          }
                                        ])
                                    ).values()
                                  );
                                  return b;
                                })();
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return (() => {
                                    const __composite = [
                                      { label: null, value: "Option 1" },
                                      { label: null, value: "Option 2" },
                                      { label: null, value: "Option 3" }
                                    ];
                                    __composite["0"]["label"] = "Current";
                                    __composite["1"]["label"] = "Denied";
                                    __composite["2"]["label"] = "Waiting";
                                    return __composite;
                                  })();
                                }
                                throw e;
                              }
                            })()}
                            optionsSlot={
                              <React.Fragment>
                                <AntdSegmentedOption
                                  className={classNames(
                                    "__wab_instance",
                                    sty.segmentedOption__nqtQ
                                  )}
                                  value={"Option 1"}
                                >
                                  <div
                                    className={classNames(
                                      "all",
                                      sty.freeBox__soE5A
                                    )}
                                  >
                                    <PlasmicImg__
                                      alt={""}
                                      className={classNames(sty.img__i82Xl)}
                                      displayHeight={"auto"}
                                      displayMaxHeight={"none"}
                                      displayMaxWidth={"none"}
                                      displayMinHeight={"0"}
                                      displayMinWidth={"0"}
                                      displayWidth={"auto"}
                                      src={
                                        "/plasmic/inventory/images/home-outlined.svg"
                                      }
                                    />

                                    <div
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text__cgyz8
                                      )}
                                    >
                                      {"Option 1"}
                                    </div>
                                  </div>
                                </AntdSegmentedOption>
                                <AntdSegmentedOption
                                  className={classNames(
                                    "__wab_instance",
                                    sty.segmentedOption__keZqu
                                  )}
                                  value={"Option 2"}
                                >
                                  <div
                                    className={classNames(
                                      "all",
                                      sty.freeBox__gbrIj
                                    )}
                                  >
                                    <PlasmicImg__
                                      alt={""}
                                      className={classNames(sty.img__uuKl4)}
                                      displayHeight={"auto"}
                                      displayMaxHeight={"none"}
                                      displayMaxWidth={"none"}
                                      displayMinHeight={"0"}
                                      displayMinWidth={"0"}
                                      displayWidth={"auto"}
                                      src={
                                        "/plasmic/inventory/images/home-outlined.svg"
                                      }
                                    />

                                    <div
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text__lFih7
                                      )}
                                    >
                                      {"Option 2"}
                                    </div>
                                  </div>
                                </AntdSegmentedOption>
                              </React.Fragment>
                            }
                            useSlotOptions={false}
                            value={generateStateValueProp($state, [
                              "segmented2",
                              "value"
                            ])}
                          />

                          {(() => {
                            const child$Props = {
                              className: classNames(
                                "__wab_instance",
                                sty.table
                              ),
                              data: (() => {
                                function removeNulls(obj) {
                                  if (Array.isArray(obj)) {
                                    return obj.map(removeNulls);
                                  }
                                  if (obj !== null && typeof obj === "object") {
                                    const cleaned = {};
                                    for (const [key, value] of Object.entries(
                                      obj
                                    )) {
                                      if (value !== null) {
                                        cleaned[key] = removeNulls(value);
                                      }
                                    }
                                    return cleaned;
                                  }
                                  return obj;
                                }
                                let a = removeNulls($ctx.support_tickets);
                                return a?.filter(
                                  item =>
                                    item.status_id == $state.segmented2.value
                                );
                              })(),

                              fields: (() => {
                                const __composite = [
                                  {
                                    key: "ticket_id",
                                    fieldId: "ticket_id",
                                    isHidden: null
                                  },
                                  {
                                    key: "created_at",
                                    fieldId: "created_at",
                                    title: null
                                  },
                                  {
                                    key: "updated_at",
                                    fieldId: "updated_at",
                                    isHidden: null
                                  },
                                  {
                                    key: "category",
                                    fieldId: "category",
                                    title: null
                                  },
                                  {
                                    key: "priority",
                                    fieldId: "priority",
                                    isHidden: null
                                  },
                                  {
                                    key: "title",
                                    fieldId: "title",
                                    title: null,
                                    expr: null
                                  },
                                  {
                                    key: "description",
                                    fieldId: "description",
                                    title: null,
                                    expr: null
                                  },
                                  {
                                    key: "resolution_notes",
                                    fieldId: "resolution_notes",
                                    title: null,
                                    expr: null
                                  },
                                  {
                                    key: "subcategory",
                                    fieldId: "subcategory",
                                    title: null
                                  },
                                  {
                                    key: "user_error_details",
                                    fieldId: "user_error_details",
                                    title: null
                                  },
                                  {
                                    key: "status",
                                    fieldId: "status",
                                    title: null,
                                    isHidden: null
                                  },
                                  {
                                    key: "created_by_tech",
                                    fieldId: "created_by_tech",
                                    expr: null,
                                    title: null
                                  },
                                  {
                                    key: "created_by_account_tech",
                                    fieldId: "created_by_account_tech",
                                    title: null,
                                    expr: null
                                  },
                                  {
                                    key: "status_id",
                                    fieldId: "status_id",
                                    isHidden: null
                                  },
                                  {
                                    key: "html_feedback",
                                    fieldId: "html_feedback",
                                    isHidden: null
                                  }
                                ];
                                __composite["0"]["isHidden"] = true;
                                __composite["1"]["title"] = "Date";
                                __composite["2"]["isHidden"] = true;
                                __composite["3"]["title"] = "Category";
                                __composite["4"]["isHidden"] = true;
                                __composite["5"]["title"] = "Title";
                                __composite["5"]["expr"] = (
                                  currentItem,
                                  currentValue
                                ) => {
                                  return (
                                    (currentValue ?? "").slice(0, 50) + "..."
                                  );
                                };
                                __composite["6"]["title"] = "Desc";
                                __composite["6"]["expr"] = (
                                  currentItem,
                                  currentValue
                                ) => {
                                  return (
                                    (currentValue ?? "").slice(0, 50) + "..."
                                  );
                                };
                                __composite["7"]["title"] = "Notes";
                                __composite["7"]["expr"] = (
                                  currentItem,
                                  currentValue
                                ) => {
                                  return (
                                    (currentValue ?? "").slice(0, 50) + "..."
                                  );
                                };
                                __composite["8"]["title"] = "Fault";
                                __composite["9"]["title"] = "User mistake";
                                __composite["10"]["title"] = "Status";
                                __composite["10"]["isHidden"] = true;
                                __composite["11"]["expr"] = (
                                  currentItem,
                                  currentValue
                                ) => {
                                  return currentValue?.created_by ?? null;
                                };
                                __composite["11"]["title"] = "Tech";
                                __composite["12"]["title"] = "Account";
                                __composite["12"]["expr"] = (
                                  currentItem,
                                  currentValue
                                ) => {
                                  return currentValue?.name ?? null;
                                };
                                __composite["13"]["isHidden"] = true;
                                __composite["14"]["isHidden"] = true;
                                return __composite;
                              })(),

                              hideColumnPicker: true,
                              hideExports: true,
                              hideSearch: true,
                              onRowSelectionChanged: async (
                                ...eventArgs: any
                              ) => {
                                generateStateOnChangePropForCodeComponents(
                                  $state,
                                  "selectedRowKey",
                                  ["table", "selectedRowKey"],
                                  RichTable_Helpers
                                ).apply(null, eventArgs);
                                generateStateOnChangePropForCodeComponents(
                                  $state,
                                  "selectedRow",
                                  ["table", "selectedRow"],
                                  RichTable_Helpers
                                ).apply(null, eventArgs);
                                generateStateOnChangePropForCodeComponents(
                                  $state,
                                  "selectedRows",
                                  ["table", "selectedRows"],
                                  RichTable_Helpers
                                ).apply(null, eventArgs);
                                generateStateOnChangePropForCodeComponents(
                                  $state,
                                  "selectedRowKeys",
                                  ["table", "selectedRowKeys"],
                                  RichTable_Helpers
                                ).apply(null, eventArgs);
                              },
                              rowActions: (() => {
                                const __composite = [
                                  { type: "item", label: null, onClick: null }
                                ];
                                __composite["0"]["label"] =
                                  $state.segmented2.value == 5 ? "" : "Review";
                                __composite["0"]["onClick"] = async (
                                  rowKey,
                                  row
                                ) => {
                                  const $steps = {};

                                  $steps["invokeGlobalAction"] = true
                                    ? (() => {
                                        const actionArgs = {
                                          args: [
                                            "support_tickets",
                                            {
                                              eq: {
                                                ticket_id: row.ticket_id
                                              }
                                            },
                                            { status_id: 8 },
                                            true
                                          ]
                                        };
                                        return $globalActions[
                                          "SupabaseActions.update"
                                        ]?.apply(null, [...actionArgs.args]);
                                      })()
                                    : undefined;
                                  if (
                                    $steps["invokeGlobalAction"] != null &&
                                    typeof $steps["invokeGlobalAction"] ===
                                      "object" &&
                                    typeof $steps["invokeGlobalAction"].then ===
                                      "function"
                                  ) {
                                    $steps["invokeGlobalAction"] =
                                      await $steps["invokeGlobalAction"];
                                  }

                                  $steps["updateFaultyTicket"] = true
                                    ? (() => {
                                        const actionArgs = {
                                          variable: {
                                            objRoot: $state,
                                            variablePath: ["faultyTicket"]
                                          },
                                          operation: 0,
                                          value: (() => {
                                            let a = JSON.parse(
                                              JSON.stringify(row)
                                            );
                                            a.status_id = 8;
                                            return a;
                                          })()
                                        };
                                        return (({
                                          variable,
                                          value,
                                          startIndex,
                                          deleteCount
                                        }) => {
                                          if (!variable) {
                                            return;
                                          }
                                          const { objRoot, variablePath } =
                                            variable;

                                          $stateSet(
                                            objRoot,
                                            variablePath,
                                            value
                                          );
                                          return value;
                                        })?.apply(null, [actionArgs]);
                                      })()
                                    : undefined;
                                  if (
                                    $steps["updateFaultyTicket"] != null &&
                                    typeof $steps["updateFaultyTicket"] ===
                                      "object" &&
                                    typeof $steps["updateFaultyTicket"].then ===
                                      "function"
                                  ) {
                                    $steps["updateFaultyTicket"] =
                                      await $steps["updateFaultyTicket"];
                                  }
                                };
                                return __composite;
                              })(),

                              scopeClassName: sty["table__instance"],
                              selectedRowKey: generateStateValueProp($state, [
                                "table",
                                "selectedRowKey"
                              ]),
                              selectedRowKeys: generateStateValueProp($state, [
                                "table",
                                "selectedRowKeys"
                              ]),
                              themeResetClassName: classNames(
                                "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                                "root_reset_k4MoYHGY6d3NVAoA3aDDg2_tags",
                                "plasmic_default_styles",
                                "plasmic_mixins",
                                styleTokensClassNames
                              )
                            };
                            initializeCodeComponentStates(
                              $state,
                              [
                                {
                                  name: "selectedRowKey",
                                  plasmicStateName: "table.selectedRowKey"
                                },
                                {
                                  name: "selectedRow",
                                  plasmicStateName: "table.selectedRow"
                                },
                                {
                                  name: "selectedRows",
                                  plasmicStateName: "table.selectedRows"
                                },
                                {
                                  name: "selectedRowKeys",
                                  plasmicStateName: "table.selectedRowKeys"
                                }
                              ],
                              [],
                              RichTable_Helpers ?? {},
                              child$Props
                            );

                            return (
                              <RichTable
                                data-plasmic-name={"table"}
                                data-plasmic-override={overrides.table}
                                {...child$Props}
                              />
                            );
                          })()}
                          {(() => {
                            try {
                              return (
                                Object.keys($state.faultyTicket ?? {}).length !=
                                0
                              );
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return true;
                              }
                              throw e;
                            }
                          })()
                            ? (() => {
                                const child$Props = {
                                  className: classNames(
                                    "__wab_instance",
                                    sty.form2
                                  ),
                                  extendedOnValuesChange: async (
                                    ...eventArgs: any
                                  ) => {
                                    generateStateOnChangePropForCodeComponents(
                                      $state,
                                      "value",
                                      ["form2", "value"],
                                      FormWrapper_Helpers
                                    ).apply(null, eventArgs);
                                  },
                                  formItems: [
                                    {
                                      label: "Name",
                                      name: "name",
                                      inputType: "Text"
                                    },
                                    {
                                      label: "Message",
                                      name: "message",
                                      inputType: "Text Area"
                                    }
                                  ],
                                  initialValues: (() => {
                                    let a = JSON.parse(
                                      JSON.stringify($state.faultyTicket ?? {})
                                    );
                                    delete a.created_by_tech;
                                    delete a.created_by_account_tech;
                                    delete a.__tag;
                                    delete a.priority;
                                    delete a.created_at;
                                    delete a.updated_at;
                                    delete a.status;
                                    return a;
                                  })(),

                                  labelCol: { span: 8, horizontalOnly: true },
                                  layout: "vertical",
                                  mode: "advanced",
                                  onFinish: async values => {
                                    const $steps = {};

                                    $steps["invokeGlobalAction"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            args: [
                                              "support_tickets",
                                              {
                                                eq: {
                                                  ticket_id:
                                                    $state.form2.value.ticket_id
                                                }
                                              },

                                              $state.form2.value,
                                              true
                                            ]
                                          };
                                          return $globalActions[
                                            "SupabaseActions.update"
                                          ]?.apply(null, [...actionArgs.args]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["invokeGlobalAction"] != null &&
                                      typeof $steps["invokeGlobalAction"] ===
                                        "object" &&
                                      typeof $steps["invokeGlobalAction"]
                                        .then === "function"
                                    ) {
                                      $steps["invokeGlobalAction"] =
                                        await $steps["invokeGlobalAction"];
                                    }

                                    $steps["refreshData"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            queryInvalidation: [
                                              "plasmic_refresh_all"
                                            ]
                                          };
                                          return (async ({
                                            queryInvalidation
                                          }) => {
                                            if (!queryInvalidation) {
                                              return;
                                            }
                                            await plasmicInvalidate(
                                              queryInvalidation
                                            );
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["refreshData"] != null &&
                                      typeof $steps["refreshData"] ===
                                        "object" &&
                                      typeof $steps["refreshData"].then ===
                                        "function"
                                    ) {
                                      $steps["refreshData"] =
                                        await $steps["refreshData"];
                                    }

                                    $steps["runActionOnForm"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            tplRef: "form",
                                            action: "clearFields"
                                          };
                                          return (({
                                            tplRef,
                                            action,
                                            args
                                          }) => {
                                            return $refs?.[tplRef]?.[action]?.(
                                              ...(args ?? [])
                                            );
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["runActionOnForm"] != null &&
                                      typeof $steps["runActionOnForm"] ===
                                        "object" &&
                                      typeof $steps["runActionOnForm"].then ===
                                        "function"
                                    ) {
                                      $steps["runActionOnForm"] =
                                        await $steps["runActionOnForm"];
                                    }

                                    $steps["updateFaultyTicket"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            variable: {
                                              objRoot: $state,
                                              variablePath: ["faultyTicket"]
                                            },
                                            operation: 1
                                          };
                                          return (({
                                            variable,
                                            value,
                                            startIndex,
                                            deleteCount
                                          }) => {
                                            if (!variable) {
                                              return;
                                            }
                                            const { objRoot, variablePath } =
                                              variable;

                                            $stateSet(
                                              objRoot,
                                              variablePath,
                                              undefined
                                            );
                                            return undefined;
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["updateFaultyTicket"] != null &&
                                      typeof $steps["updateFaultyTicket"] ===
                                        "object" &&
                                      typeof $steps["updateFaultyTicket"]
                                        .then === "function"
                                    ) {
                                      $steps["updateFaultyTicket"] =
                                        await $steps["updateFaultyTicket"];
                                    }
                                  },
                                  onIsSubmittingChange: async (
                                    ...eventArgs: any
                                  ) => {
                                    generateStateOnChangePropForCodeComponents(
                                      $state,
                                      "isSubmitting",
                                      ["form2", "isSubmitting"],
                                      FormWrapper_Helpers
                                    ).apply(null, eventArgs);
                                  },
                                  ref: ref => {
                                    $refs["form2"] = ref;
                                  },
                                  submitSlot: null,
                                  wrapperCol: { span: 16, horizontalOnly: true }
                                };
                                initializeCodeComponentStates(
                                  $state,
                                  [
                                    {
                                      name: "value",
                                      plasmicStateName: "form2.value"
                                    },
                                    {
                                      name: "isSubmitting",
                                      plasmicStateName: "form2.isSubmitting"
                                    }
                                  ],
                                  [],
                                  FormWrapper_Helpers ?? {},
                                  child$Props
                                );

                                return (
                                  <FormWrapper
                                    data-plasmic-name={"form2"}
                                    data-plasmic-override={overrides.form2}
                                    {...child$Props}
                                  >
                                    <FormItemWrapper
                                      className={classNames(
                                        "__wab_instance",
                                        sty.formField___4MiNh
                                      )}
                                      label={"Notes"}
                                      name={"resolution_notes"}
                                    >
                                      {(() => {
                                        const child$Props = {
                                          autoSize: true,
                                          className: classNames(
                                            "__wab_instance",
                                            sty.textArea10
                                          ),
                                          onChange: async (
                                            ...eventArgs: any
                                          ) => {
                                            generateStateOnChangePropForCodeComponents(
                                              $state,
                                              "value",
                                              ["textArea10", "value"],
                                              AntdTextArea_Helpers
                                            ).apply(null, eventArgs);
                                          },
                                          placeholder:
                                            "Porque no pregunte bien antes de hacer el reporte",
                                          value: generateStateValueProp(
                                            $state,
                                            ["textArea10", "value"]
                                          )
                                        };
                                        initializeCodeComponentStates(
                                          $state,
                                          [
                                            {
                                              name: "value",
                                              plasmicStateName:
                                                "textArea10.value"
                                            }
                                          ],
                                          [],
                                          AntdTextArea_Helpers ?? {},
                                          child$Props
                                        );

                                        return (
                                          <AntdTextArea
                                            data-plasmic-name={"textArea10"}
                                            data-plasmic-override={
                                              overrides.textArea10
                                            }
                                            {...child$Props}
                                          />
                                        );
                                      })()}
                                    </FormItemWrapper>
                                    <div
                                      className={classNames(
                                        "all",
                                        sty.freeBox__aqzqn
                                      )}
                                    >
                                      <FormItemWrapper
                                        className={classNames(
                                          "__wab_instance",
                                          sty.formField__cl3Xq
                                        )}
                                        label={"Category"}
                                        name={"category"}
                                        rules={[{ ruleType: "required" }]}
                                      >
                                        <AntdSelect
                                          data-plasmic-name={"select5"}
                                          data-plasmic-override={
                                            overrides.select5
                                          }
                                          className={classNames(
                                            "__wab_instance",
                                            sty.select5
                                          )}
                                          defaultStylesClassName={classNames(
                                            "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                                            "plasmic_default_styles",
                                            "plasmic_mixins",
                                            styleTokensClassNames
                                          )}
                                          onChange={async (
                                            ...eventArgs: any
                                          ) => {
                                            generateStateOnChangeProp($state, [
                                              "select5",
                                              "value"
                                            ]).apply(null, eventArgs);
                                          }}
                                          options={(() => {
                                            const __composite = [
                                              {
                                                value: null,
                                                label: null,
                                                type: "option"
                                              },
                                              {
                                                value: null,
                                                label: null,
                                                type: "option"
                                              }
                                            ];
                                            __composite["0"]["value"] =
                                              "hardware";
                                            __composite["0"]["label"] =
                                              "Hardware";
                                            __composite["1"]["value"] =
                                              "software";
                                            __composite["1"]["label"] =
                                              "Software";
                                            return __composite;
                                          })()}
                                          placeholder={"Select..."}
                                          popupScopeClassName={
                                            sty["select5__popup"]
                                          }
                                          value={generateStateValueProp(
                                            $state,
                                            ["select5", "value"]
                                          )}
                                        />
                                      </FormItemWrapper>
                                      <FormItemWrapper
                                        className={classNames(
                                          "__wab_instance",
                                          sty.formField__ce268
                                        )}
                                        label={
                                          <div
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.text__qjRx4
                                            )}
                                          >
                                            {"Subcategory"}
                                          </div>
                                        }
                                        name={"subcategory"}
                                      >
                                        <AntdSelect
                                          data-plasmic-name={"select6"}
                                          data-plasmic-override={
                                            overrides.select6
                                          }
                                          className={classNames(
                                            "__wab_instance",
                                            sty.select6
                                          )}
                                          defaultStylesClassName={classNames(
                                            "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                                            "plasmic_default_styles",
                                            "plasmic_mixins",
                                            styleTokensClassNames
                                          )}
                                          onChange={async (
                                            ...eventArgs: any
                                          ) => {
                                            generateStateOnChangeProp($state, [
                                              "select6",
                                              "value"
                                            ]).apply(null, eventArgs);
                                          }}
                                          options={(() => {
                                            const __composite = [
                                              {
                                                value: null,
                                                label: null,
                                                type: "option"
                                              },
                                              {
                                                value: null,
                                                label: null,
                                                type: "option"
                                              }
                                            ];
                                            __composite["0"]["value"] =
                                              "legit_issue";
                                            __composite["0"]["label"] =
                                              "System error";
                                            __composite["1"]["value"] =
                                              "user_error";
                                            __composite["1"]["label"] =
                                              "You error";
                                            return __composite;
                                          })()}
                                          placeholder={"Select..."}
                                          popupScopeClassName={
                                            sty["select6__popup"]
                                          }
                                          value={generateStateValueProp(
                                            $state,
                                            ["select6", "value"]
                                          )}
                                        />
                                      </FormItemWrapper>
                                      <FormItemWrapper
                                        className={classNames(
                                          "__wab_instance",
                                          sty.formField__w31T6
                                        )}
                                        label={"Status"}
                                        name={"status_id"}
                                      >
                                        <AntdSelect
                                          data-plasmic-name={"select4"}
                                          data-plasmic-override={
                                            overrides.select4
                                          }
                                          className={classNames(
                                            "__wab_instance",
                                            sty.select4
                                          )}
                                          defaultStylesClassName={classNames(
                                            "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                                            "plasmic_default_styles",
                                            "plasmic_mixins",
                                            styleTokensClassNames
                                          )}
                                          onChange={async (
                                            ...eventArgs: any
                                          ) => {
                                            generateStateOnChangeProp($state, [
                                              "select4",
                                              "value"
                                            ]).apply(null, eventArgs);
                                          }}
                                          options={(() => {
                                            try {
                                              return (() => {
                                                let a = [
                                                  {
                                                    label: "Denied",
                                                    value: 11
                                                  },
                                                  {
                                                    label: "Complete",
                                                    value: 4
                                                  },
                                                  {
                                                    label: "Working",
                                                    value: 8
                                                  }
                                                ];

                                                return a;
                                              })();
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return (() => {
                                                  const __composite = [
                                                    {
                                                      value: null,
                                                      label: null,
                                                      type: "option"
                                                    },
                                                    {
                                                      value: null,
                                                      label: null,
                                                      type: "option"
                                                    }
                                                  ];
                                                  __composite["0"]["value"] =
                                                    "11";
                                                  __composite["0"]["label"] =
                                                    "Denied";
                                                  __composite["1"]["value"] =
                                                    "4";
                                                  __composite["1"]["label"] =
                                                    "Complete";
                                                  return __composite;
                                                })();
                                              }
                                              throw e;
                                            }
                                          })()}
                                          placeholder={"Select..."}
                                          popupScopeClassName={
                                            sty["select4__popup"]
                                          }
                                          value={generateStateValueProp(
                                            $state,
                                            ["select4", "value"]
                                          )}
                                        />
                                      </FormItemWrapper>
                                    </div>
                                    <FormItemWrapper
                                      className={classNames(
                                        "__wab_instance",
                                        sty.formField__bs3V3
                                      )}
                                      label={"Error code"}
                                      name={"description"}
                                    >
                                      {(() => {
                                        const child$Props = {
                                          autoSize: false,
                                          className: classNames(
                                            "__wab_instance",
                                            sty.textArea6
                                          ),
                                          onChange: async (
                                            ...eventArgs: any
                                          ) => {
                                            generateStateOnChangePropForCodeComponents(
                                              $state,
                                              "value",
                                              ["textArea6", "value"],
                                              AntdTextArea_Helpers
                                            ).apply(null, eventArgs);
                                          },
                                          placeholder:
                                            "Duplicate IMEIs found: {356321742427776}",
                                          value: generateStateValueProp(
                                            $state,
                                            ["textArea6", "value"]
                                          )
                                        };
                                        initializeCodeComponentStates(
                                          $state,
                                          [
                                            {
                                              name: "value",
                                              plasmicStateName:
                                                "textArea6.value"
                                            }
                                          ],
                                          [],
                                          AntdTextArea_Helpers ?? {},
                                          child$Props
                                        );

                                        return (
                                          <AntdTextArea
                                            data-plasmic-name={"textArea6"}
                                            data-plasmic-override={
                                              overrides.textArea6
                                            }
                                            {...child$Props}
                                          />
                                        );
                                      })()}
                                    </FormItemWrapper>
                                    <FormItemWrapper
                                      className={classNames(
                                        "__wab_instance",
                                        sty.formField__e7Wnu
                                      )}
                                      label={"What did you do?"}
                                      name={"user_error_details"}
                                    >
                                      {(() => {
                                        const child$Props = {
                                          autoSize: true,
                                          className: classNames(
                                            "__wab_instance",
                                            sty.textArea7
                                          ),
                                          onChange: async (
                                            ...eventArgs: any
                                          ) => {
                                            generateStateOnChangePropForCodeComponents(
                                              $state,
                                              "value",
                                              ["textArea7", "value"],
                                              AntdTextArea_Helpers
                                            ).apply(null, eventArgs);
                                          },
                                          placeholder:
                                            "Cree err\u00f3neamente un reporte",
                                          value: generateStateValueProp(
                                            $state,
                                            ["textArea7", "value"]
                                          )
                                        };
                                        initializeCodeComponentStates(
                                          $state,
                                          [
                                            {
                                              name: "value",
                                              plasmicStateName:
                                                "textArea7.value"
                                            }
                                          ],
                                          [],
                                          AntdTextArea_Helpers ?? {},
                                          child$Props
                                        );

                                        return (
                                          <AntdTextArea
                                            data-plasmic-name={"textArea7"}
                                            data-plasmic-override={
                                              overrides.textArea7
                                            }
                                            {...child$Props}
                                          />
                                        );
                                      })()}
                                    </FormItemWrapper>
                                    <FormItemWrapper
                                      className={classNames(
                                        "__wab_instance",
                                        sty.formField__gcbqb
                                      )}
                                      label={"What do you want?"}
                                      name={"title"}
                                      rules={[{ ruleType: "required" }]}
                                    >
                                      {(() => {
                                        const child$Props = {
                                          autoSize: true,
                                          className: classNames(
                                            "__wab_instance",
                                            sty.textArea8
                                          ),
                                          onChange: async (
                                            ...eventArgs: any
                                          ) => {
                                            generateStateOnChangePropForCodeComponents(
                                              $state,
                                              "value",
                                              ["textArea8", "value"],
                                              AntdTextArea_Helpers
                                            ).apply(null, eventArgs);
                                          },
                                          placeholder:
                                            "Borrar el reporte del telefono ID 323934",
                                          value: generateStateValueProp(
                                            $state,
                                            ["textArea8", "value"]
                                          )
                                        };
                                        initializeCodeComponentStates(
                                          $state,
                                          [
                                            {
                                              name: "value",
                                              plasmicStateName:
                                                "textArea8.value"
                                            }
                                          ],
                                          [],
                                          AntdTextArea_Helpers ?? {},
                                          child$Props
                                        );

                                        return (
                                          <AntdTextArea
                                            data-plasmic-name={"textArea8"}
                                            data-plasmic-override={
                                              overrides.textArea8
                                            }
                                            {...child$Props}
                                          />
                                        );
                                      })()}
                                    </FormItemWrapper>
                                    <FormItemWrapper
                                      className={classNames(
                                        "__wab_instance",
                                        sty.formField__deIw
                                      )}
                                      label={"Why did you do that mistake?"}
                                      name={"description"}
                                    >
                                      {(() => {
                                        const child$Props = {
                                          autoSize: true,
                                          className: classNames(
                                            "__wab_instance",
                                            sty.textArea9
                                          ),
                                          onChange: async (
                                            ...eventArgs: any
                                          ) => {
                                            generateStateOnChangePropForCodeComponents(
                                              $state,
                                              "value",
                                              ["textArea9", "value"],
                                              AntdTextArea_Helpers
                                            ).apply(null, eventArgs);
                                          },
                                          placeholder:
                                            "Porque no pregunte bien antes de hacer el reporte",
                                          value: generateStateValueProp(
                                            $state,
                                            ["textArea9", "value"]
                                          )
                                        };
                                        initializeCodeComponentStates(
                                          $state,
                                          [
                                            {
                                              name: "value",
                                              plasmicStateName:
                                                "textArea9.value"
                                            }
                                          ],
                                          [],
                                          AntdTextArea_Helpers ?? {},
                                          child$Props
                                        );

                                        return (
                                          <AntdTextArea
                                            data-plasmic-name={"textArea9"}
                                            data-plasmic-override={
                                              overrides.textArea9
                                            }
                                            {...child$Props}
                                          />
                                        );
                                      })()}
                                    </FormItemWrapper>
                                    <FormItemWrapper
                                      className={classNames(
                                        "__wab_instance",
                                        sty.formField__c35Ed
                                      )}
                                      label={"HTML feedback"}
                                      name={"html_feedback"}
                                    >
                                      <JoditEditor
                                        data-plasmic-name={"joditEditor"}
                                        data-plasmic-override={
                                          overrides.joditEditor
                                        }
                                        className={classNames(
                                          "__wab_instance",
                                          sty.joditEditor
                                        )}
                                        onChange={async (...eventArgs: any) => {
                                          generateStateOnChangeProp($state, [
                                            "joditEditor",
                                            "value"
                                          ]).apply(null, eventArgs);
                                        }}
                                        value={generateStateValueProp($state, [
                                          "joditEditor",
                                          "value"
                                        ])}
                                      />
                                    </FormItemWrapper>
                                    <AntdButton
                                      className={classNames(
                                        "__wab_instance",
                                        sty.button__jSwxu
                                      )}
                                      submitsForm={true}
                                      type={"primary"}
                                    >
                                      <div
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text__gpu2U
                                        )}
                                      >
                                        {"Submit"}
                                      </div>
                                    </AntdButton>
                                  </FormWrapper>
                                );
                              })()
                            : null}
                        </div>
                      </AntdModal>
                    );
                  })()}
                </React.Fragment>
              )}
            </DataCtxReader__>
          </SupabaseDataProvider>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "modal",
    "tabs",
    "form",
    "select",
    "slider",
    "select2",
    "select3",
    "textArea3",
    "textArea4",
    "textArea5",
    "textArea2",
    "segmented",
    "steps",
    "embedHtml",
    "select7",
    "modal2",
    "segmented2",
    "table",
    "form2",
    "textArea10",
    "select5",
    "select6",
    "select4",
    "textArea6",
    "textArea7",
    "textArea8",
    "textArea9",
    "joditEditor"
  ],
  modal: [
    "modal",
    "tabs",
    "form",
    "select",
    "slider",
    "select2",
    "select3",
    "textArea3",
    "textArea4",
    "textArea5",
    "textArea2",
    "segmented",
    "steps",
    "embedHtml",
    "select7"
  ],
  tabs: [
    "tabs",
    "form",
    "select",
    "slider",
    "select2",
    "select3",
    "textArea3",
    "textArea4",
    "textArea5",
    "textArea2",
    "segmented",
    "steps",
    "embedHtml"
  ],
  form: [
    "form",
    "select",
    "slider",
    "select2",
    "select3",
    "textArea3",
    "textArea4",
    "textArea5",
    "textArea2"
  ],
  select: ["select"],
  slider: ["slider"],
  select2: ["select2"],
  select3: ["select3"],
  textArea3: ["textArea3"],
  textArea4: ["textArea4"],
  textArea5: ["textArea5"],
  textArea2: ["textArea2"],
  segmented: ["segmented"],
  steps: ["steps"],
  embedHtml: ["embedHtml"],
  select7: ["select7"],
  modal2: [
    "modal2",
    "segmented2",
    "table",
    "form2",
    "textArea10",
    "select5",
    "select6",
    "select4",
    "textArea6",
    "textArea7",
    "textArea8",
    "textArea9",
    "joditEditor"
  ],
  segmented2: ["segmented2"],
  table: ["table"],
  form2: [
    "form2",
    "textArea10",
    "select5",
    "select6",
    "select4",
    "textArea6",
    "textArea7",
    "textArea8",
    "textArea9",
    "joditEditor"
  ],
  textArea10: ["textArea10"],
  select5: ["select5"],
  select6: ["select6"],
  select4: ["select4"],
  textArea6: ["textArea6"],
  textArea7: ["textArea7"],
  textArea8: ["textArea8"],
  textArea9: ["textArea9"],
  joditEditor: ["joditEditor"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  modal: typeof AntdModal;
  tabs: typeof AntdTabs;
  form: typeof FormWrapper;
  select: typeof AntdSelect;
  slider: typeof Slider;
  select2: typeof AntdSelect;
  select3: typeof AntdSelect;
  textArea3: typeof AntdTextArea;
  textArea4: typeof AntdTextArea;
  textArea5: typeof AntdTextArea;
  textArea2: typeof AntdTextArea;
  segmented: typeof AntdSegmented;
  steps: typeof AntdSteps;
  embedHtml: typeof Embed;
  select7: typeof AntdSelect;
  modal2: typeof AntdModal;
  segmented2: typeof AntdSegmented;
  table: typeof RichTable;
  form2: typeof FormWrapper;
  textArea10: typeof AntdTextArea;
  select5: typeof AntdSelect;
  select6: typeof AntdSelect;
  select4: typeof AntdSelect;
  textArea6: typeof AntdTextArea;
  textArea7: typeof AntdTextArea;
  textArea8: typeof AntdTextArea;
  textArea9: typeof AntdTextArea;
  joditEditor: typeof JoditEditor;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicReportIssue__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicReportIssue__VariantsArgs;
    args?: PlasmicReportIssue__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicReportIssue__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicReportIssue__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicReportIssue__ArgProps,
          internalVariantPropNames: PlasmicReportIssue__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicReportIssue__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicReportIssue";
  } else {
    func.displayName = `PlasmicReportIssue.${nodeName}`;
  }
  return func;
}

export const PlasmicReportIssue = Object.assign(
  // Top-level PlasmicReportIssue renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    modal: makeNodeComponent("modal"),
    tabs: makeNodeComponent("tabs"),
    form: makeNodeComponent("form"),
    select: makeNodeComponent("select"),
    slider: makeNodeComponent("slider"),
    select2: makeNodeComponent("select2"),
    select3: makeNodeComponent("select3"),
    textArea3: makeNodeComponent("textArea3"),
    textArea4: makeNodeComponent("textArea4"),
    textArea5: makeNodeComponent("textArea5"),
    textArea2: makeNodeComponent("textArea2"),
    segmented: makeNodeComponent("segmented"),
    steps: makeNodeComponent("steps"),
    embedHtml: makeNodeComponent("embedHtml"),
    select7: makeNodeComponent("select7"),
    modal2: makeNodeComponent("modal2"),
    segmented2: makeNodeComponent("segmented2"),
    table: makeNodeComponent("table"),
    form2: makeNodeComponent("form2"),
    textArea10: makeNodeComponent("textArea10"),
    select5: makeNodeComponent("select5"),
    select6: makeNodeComponent("select6"),
    select4: makeNodeComponent("select4"),
    textArea6: makeNodeComponent("textArea6"),
    textArea7: makeNodeComponent("textArea7"),
    textArea8: makeNodeComponent("textArea8"),
    textArea9: makeNodeComponent("textArea9"),
    joditEditor: makeNodeComponent("joditEditor"),

    // Metadata about props expected for PlasmicReportIssue
    internalVariantProps: PlasmicReportIssue__VariantProps,
    internalArgProps: PlasmicReportIssue__ArgProps
  }
);

export default PlasmicReportIssue;
/* prettier-ignore-end */
